var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { PhysicsSystem } from "../components/physics/Physics.js";
import { GameModel } from "../game/GameModel.js";
import { InputManager } from "../inputs/InputManager.js";
import { md5 } from "../utils/md5.js";
import { nanoid } from "nanoid";
import { TouchListener } from "../inputs/TouchListener.js";
import { PlayerEventManager } from "../inputs/PlayerEventManager.js";
import { GameCoordinator } from "../game/GameCoordinator.js";
import { P as PlayerInputSchema } from "../PlayerInput-ad722e2d.js";
import "../components/types.js";
import "../enums-86f58524.js";
import "../decorators/type.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../global-33d5eebf.js";
import "../components/ComponentRegistry.js";
import "../utils/byteArray.js";
import "../components/entity/Types.js";
import "@dimforge/rapier2d-compat";
import "../console/flags.js";
import "../persist/persist.js";
import "../console/editor.js";
import "../console/floatingwindow.js";
import "lodash";
import "../Description-c36d0b9a.js";
import "../Attach-abbbd93e.js";
import "../utils/vector.js";
import "../utils/windowSessionStorage.js";
import "pixi.js";
import "../FrameRate-7ce72a03.js";
import "../Collisions-9e9492fb.js";
import "../Physics-8d447f7a.js";
import "../entity/EntityFactory.js";
import "../constants/index.js";
import "../loader/AssetLoader.js";
import "../loader/ImageLoader.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "../utils/colors.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
import "toposort";
import "../Parent-b4f1af10.js";
import "../components/core/ListenEntityCreation.js";
import "../Random-b6daba3a.js";
import "../SpatialMap-56228ece.js";
import "../ui/UIService.js";
import "../utils/playSound.js";
import "../TimeDilation-41a74cd7.js";
import "pixi-viewport";
import "../game/Ticker.js";
class CoreConnectionInstance {
  constructor(player, inputManager, options) {
    __publicField(this, "instanceId", nanoid());
    __publicField(this, "stateRequested", null);
    __publicField(this, "frameOffset", 8);
    __publicField(this, "sendingState", false);
    __publicField(this, "leavingPlayers", []);
    __publicField(this, "inRoom", "");
    __publicField(this, "nickname", "");
    __publicField(this, "listening");
    __publicField(this, "touchListener");
    __publicField(this, "address", "");
    __publicField(this, "subscriptions", {});
    __publicField(this, "onceSubscriptions", {});
    __publicField(this, "messageListeners", []);
    __publicField(this, "connectListeners", []);
    __publicField(this, "disconnectListeners", []);
    __publicField(this, "rooms", {});
    __publicField(this, "roomStates", {});
    __publicField(this, "players", []);
    __publicField(this, "localPlayers", []);
    __publicField(this, "roomSubs", {});
    __publicField(this, "solohost");
    __publicField(this, "eventsManager", new PlayerEventManager());
    __publicField(this, "_onPlayerJoin");
    __publicField(this, "_onPlayerLeave");
    __publicField(this, "frameSkipCheck", (gameModel) => {
      var _a, _b;
      const room = this.roomStates[gameModel.roomId];
      const frameStack = room == null ? void 0 : room.frameStack;
      if (this.leavingPlayers.length) {
        for (let i = 0; i < this.leavingPlayers.length; ++i) {
          if (this.leavingPlayers[i][1] === gameModel.frame) {
            console.log("removing player", this.leavingPlayers[i][0], gameModel.frame);
            this._onPlayerLeave(gameModel, this.leavingPlayers[i][0]);
            delete frameStack[this.leavingPlayers[i][0]];
            this.leavingPlayers.splice(i, 1);
            i--;
          }
        }
      }
      const players = gameModel.getComponentActives("PlayerInput");
      if (!frameStack) {
        console.error("no room frame stack", gameModel.roomId, this.roomStates, this.instanceId);
        throw new Error("no room frame stack");
      }
      for (let i = 0; i < players.length; ++i) {
        let player = players[i];
        if (gameModel.hasComponent(player, PlayerInputSchema)) {
          const PlayerInput = gameModel.getTypedUnsafe(player, PlayerInputSchema);
          const netId = PlayerInput.id;
          while ((((_b = (_a = frameStack[netId]) == null ? void 0 : _a[0]) == null ? void 0 : _b.frame) ?? Infinity) < gameModel.frame) {
            console.error("old frame received:" + netId);
            frameStack[netId].shift();
          }
          if (!frameStack[netId] || !frameStack[netId][0]) {
            console.error("dropping slow frame", netId, gameModel.frame);
            return true;
          }
        }
      }
      return false;
    });
    __publicField(this, "generateFrameStack", (gameModel, playerId, frame) => {
      const initalFrameOffset = this.frameOffset;
      const roomState = this.roomStates[gameModel.roomId];
      roomState.frameStack[playerId] = new Array(initalFrameOffset).fill({ keys: {}, frame: 0 }).map((_, ind) => {
        return {
          frame: frame + ind,
          keys: InputManager.buildKeyMap(),
          events: [],
          playerId
        };
      });
    });
    this.inputManager = inputManager;
    this.options = options;
    options.solohost = options.solohost ?? false;
    this.solohost = options.solohost ?? false;
    if (options.touchRegions) {
      this.touchListener = new TouchListener(this.inputManager);
    }
    if (!Array.isArray(player)) {
      player = [player];
    }
    for (let i = 0; i < player.length; ++i) {
      const playerConnection = {
        ...player[i],
        connected: false,
        connectionTime: 0,
        currentRoomId: null,
        hostedRooms: []
      };
      this.localPlayers.push(playerConnection);
      this.players.push(playerConnection);
    }
    this.on("message", (message, time, playerId) => {
      this.messageListeners.forEach((listener) => listener(message, time, playerId));
    });
    this.on("updateRoom", (room) => {
      var _a;
      if (room.players.length === 0) {
        delete this.rooms[room.roomId];
        delete this.roomStates[room.roomId];
        (_a = this.roomSubs[room.roomId]) == null ? void 0 : _a.forEach((sub) => sub());
        delete this.roomSubs[room.roomId];
      } else {
        this.rooms[room.roomId] = room;
      }
    });
    this.on("rooms", (rooms) => {
      this.rooms = rooms;
    });
    this.on("connect", (player2) => {
      this.connectListeners.forEach((listener) => listener(player2));
      if (Object.keys(this.rooms).length) {
        this.emit("rooms", this.rooms);
      }
    });
    this.on("leaveRoom", (playerId, roomId) => {
      var _a;
      this.rooms[roomId] = {
        ...this.rooms[roomId],
        players: this.rooms[roomId].players.filter((player2) => player2 !== playerId)
      };
      if (this.rooms[roomId].players.length === 0) {
        delete this.rooms[roomId];
        delete this.roomStates[roomId];
        (_a = this.roomSubs[roomId]) == null ? void 0 : _a.forEach((sub) => sub());
        delete this.roomSubs[roomId];
      }
    });
    this.on("joinRoom", (playerId, roomId) => {
      this.rooms[roomId] = {
        ...this.rooms[roomId],
        players: [...this.rooms[roomId].players, playerId]
      };
    });
    this.on("userDisconnect", (playerId, lastFrame) => {
      var _a;
      const player2 = this.players.find((player3) => player3.netId === playerId);
      if (!player2) {
        console.error("Something went horribly wrong, player not found", playerId, this.players);
        return;
      }
      this.players = this.players.filter((player3) => player3.netId !== playerId);
      this.localPlayers = this.localPlayers.filter((player3) => player3.netId !== playerId);
      this.disconnectListeners.forEach((listener) => listener(playerId));
      const currentRoomId = player2.currentRoomId ?? "";
      if (!((_a = this.roomStates[currentRoomId]) == null ? void 0 : _a.frameStack[playerId])) {
        return;
      }
      if (!lastFrame) {
        const room = this.rooms[currentRoomId];
        if (room) {
          this.emit("leaveRoom", playerId, currentRoomId);
        }
      }
      const frameStack = this.roomStates[currentRoomId].frameStack[playerId];
      const gameModel = this.roomStates[currentRoomId].gameModel;
      lastFrame = Math.floor(this.roomStates[currentRoomId].lastFrame[playerId] / 10) * 10 + 10;
      let startingFrame;
      if (frameStack.length === 0) {
        startingFrame = gameModel.frame + 1;
      } else {
        startingFrame = this.roomStates[currentRoomId].lastFrame[playerId] + 1;
      }
      for (let i = startingFrame; i < lastFrame; i += 1) {
        frameStack.push({
          keys: InputManager.buildKeyMap(),
          frame: i,
          events: [],
          playerId
        });
      }
      const leavingIndex = this.leavingPlayers.findIndex(([playerId2]) => playerId2 === playerId2);
      if (leavingIndex !== -1 && this.leavingPlayers[leavingIndex][1] < lastFrame) {
        this.leavingPlayers[leavingIndex][1] = lastFrame;
      } else if (leavingIndex === -1) {
        this.leavingPlayers.push([playerId, lastFrame]);
        this.emit("userDisconnect", playerId, lastFrame);
      }
    });
    this.on("updatePlayerConnect", (player2) => {
      console.log("updatePlayerConnect", "CONNECT CHANGE", this.connectListeners.length);
      this.players = this.players.map((p) => p.netId === player2.netId ? player2 : p);
      this.connectListeners.forEach((listener) => listener(player2));
    });
  }
  get player() {
    if (this.localPlayers.length > 1) {
      throw new Error("Multiple local players");
    }
    return this.localPlayers[0];
  }
  hasRoom(roomId) {
    var _a;
    return !!((_a = this.rooms[roomId]) == null ? void 0 : _a.players.length);
  }
  updatePlayerConnect(playerConnect, index = 0) {
    const player = typeof index === "number" ? this.localPlayers[index] : this.localPlayers.find((player2) => player2.netId === index);
    if (!player) {
      return;
    }
    player.uniqueId = playerConnect.name ?? player.uniqueId;
    player.token = playerConnect.token ?? player.token;
    player.config = playerConnect.config ?? player.config;
    this.emit("updatePlayerConnect", player);
  }
  leaveRoom() {
    var _a;
    this.listening = false;
    this.sendingState = false;
    (_a = this.touchListener) == null ? void 0 : _a.replaceRegions([]);
    for (let i = 0; i < this.localPlayers.length; ++i) {
      const player = this.localPlayers[i];
      this.emit("leaveRoom", player.netId, player.currentRoomId);
      player.currentRoomId = null;
    }
  }
  async lobby() {
    return [];
  }
  updateRoom(room) {
    this.rooms[room.roomId] = room;
    this.emit("updateRoom", room);
  }
  sendMessage(message, includeSelf = true, playerIndex = 0) {
    let playerId = this.localPlayers[playerIndex].netId;
    this.emit("message", message, +/* @__PURE__ */ new Date(), playerId);
    if (includeSelf) {
      this.messageListeners.forEach((listener) => listener(message, +/* @__PURE__ */ new Date(), playerId));
    }
  }
  onReceiveMessage(cb) {
    this.messageListeners.push(cb);
    return () => {
      this.messageListeners = this.messageListeners.filter((listener) => listener !== cb);
    };
  }
  onPlayerConnect(cb) {
    this.connectListeners.push(cb);
    return () => {
      this.connectListeners = this.connectListeners.filter((listener) => listener !== cb);
    };
  }
  onPlayerDisconnect(cb) {
    this.disconnectListeners.push(cb);
    return () => {
      this.disconnectListeners = this.disconnectListeners.filter((listener) => listener !== cb);
    };
  }
  emit(event, ...args) {
  }
  cleanup() {
    var _a;
    let roomIds = this.localPlayers.map((player) => player.currentRoomId);
    for (let i = 0; i < roomIds.length; ++i) {
      let roomId = roomIds[i];
      if (!roomId) {
        return;
      }
      (_a = this.roomSubs[roomId]) == null ? void 0 : _a.forEach((sub) => sub());
      delete this.roomSubs[roomId];
      delete this.roomStates[roomId];
      delete this.rooms[roomId];
    }
  }
  on(event, callback) {
    if (!this.subscriptions[event]) {
      this.subscriptions[event] = [];
    }
    this.subscriptions[event].push(callback);
    return () => {
      this.subscriptions[event] = this.subscriptions[event].filter((cb) => cb !== callback);
    };
  }
  once(event, callback) {
    if (!this.onceSubscriptions[event]) {
      this.onceSubscriptions[event] = [];
    }
    this.onceSubscriptions[event].push(callback);
    return () => {
      this.onceSubscriptions[event] = this.onceSubscriptions[event].filter((cb) => cb !== callback);
    };
  }
  subscribeFrame(roomId) {
    this.roomSubs[roomId] = this.roomSubs[roomId] ?? [];
    if (!this.roomStates[roomId]) {
      this.roomStates[roomId] = {
        gameModel: null,
        frameStack: {},
        lastFrame: {}
      };
    }
    const room = this.roomStates[roomId];
    this.roomSubs[roomId].push(
      this.on(
        "frame",
        (frame) => {
          const obj = this.inputManager.toKeyMap(frame.keys);
          if (!room.frameStack[frame.playerId]) {
            room.frameStack[frame.playerId] = [];
          }
          room.frameStack[frame.playerId].push({
            keys: obj,
            frame: frame.frame,
            events: frame.events,
            playerId: frame.playerId
          });
          room.lastFrame[frame.playerId] = frame.frame;
        }
      )
    );
  }
  async join(roomId, {
    onPlayerLeave,
    playerConfig,
    gameInstance,
    seed,
    coreOverrides
  }) {
    if (!this.player.connected) {
      throw new Error("Not connected");
    }
    this.cleanup();
    this._onPlayerLeave = onPlayerLeave;
    if (!playerConfig) {
      playerConfig = {};
    }
    playerConfig = { ...this.player.config, ...playerConfig };
    let room = this.rooms[roomId];
    if (!room) {
      await (() => {
        console.log("Room not found, waiting for room");
        return new Promise((resolve, reject) => {
          const rejected = false;
          this.once("updateRoom", (room2) => {
            if (room2.roomId === roomId && !rejected) {
              resolve();
            }
          });
          setTimeout(() => {
            reject();
          }, this.options.roomTimeout ?? 5e3);
        });
      })();
      room = this.rooms[roomId];
      if (!room) {
        throw new Error("Timed out looking for room");
      }
    }
    return new Promise((resolve) => {
      this.roomSubs[roomId] = this.roomSubs[roomId] ?? [];
      this.roomSubs[roomId].push(
        this.on(
          "state",
          (stateJson, frameStack, timestamp) => {
            var _a, _b;
            this.subscribeFrame(roomId);
            let roomState = this.roomStates[roomId];
            this.player.currentRoomId = roomId;
            const state = JSON.parse(stateJson);
            if (!this.listening) {
              (_a = this.touchListener) == null ? void 0 : _a.replaceRegions(this.options.touchRegions ?? []);
            }
            if (!Object.keys(roomState.frameStack)) {
              roomState.frameStack = Object.entries(frameStack).reduce(
                (acc, [key, value]) => {
                  acc[+key] = value.map((frame) => {
                    return {
                      keys: this.inputManager.toKeyMap(frame.keys),
                      frame: frame.frame,
                      events: frame.events,
                      playerId: key
                    };
                  });
                  return acc;
                },
                {}
              );
            } else {
              Object.entries(frameStack).forEach(([playerId, frames]) => {
                if (!roomState.frameStack[playerId]) {
                  roomState.frameStack[playerId] = [];
                }
                frames.forEach((frame) => {
                  if (!roomState.frameStack[playerId].length || roomState.frameStack[playerId][roomState.frameStack[playerId].length - 1].frame < frame.frame) {
                    roomState.frameStack[playerId].push({
                      keys: this.inputManager.toKeyMap(frame.keys),
                      frame: frame.frame,
                      events: frame.events,
                      playerId
                    });
                  }
                });
              });
            }
            if (!roomState.gameModel || roomState.gameModel.destroyed) {
              roomState.gameModel = new GameModel(GameCoordinator.GetInstance(), gameInstance, seed, coreOverrides);
              roomState.gameModel.roomId = roomId;
            }
            if (roomState.gameModel) {
              (_b = roomState.gameModel) == null ? void 0 : _b.loadStateObject(state);
              roomState.gameModel.localNetIds = [this.player.netId];
            }
            if (roomState.frameStack[this.player.netId]) {
              this.listening = true;
            }
            resolve(roomState.gameModel);
          }
        )
      );
      this.emit("requestState", this.player.netId, roomId, JSON.stringify(playerConfig));
      this.emit("joinRoom", this.player.netId, roomId);
    });
  }
  async connect() {
  }
  async initialize(roomId, options) {
    var _a;
    if (!this.localPlayers.every((player) => player.connected) && !this.options.solohost) {
      await this.connect();
    }
    this.cleanup();
    const players = this.players.filter((player) => options.players.includes(player.netId)).sort((a, b) => a.netId.localeCompare(b.netId));
    const host = players[0];
    (_a = this.touchListener) == null ? void 0 : _a.replaceRegions(this.options.touchRegions ?? []);
    for (let i = 0; i < this.localPlayers.length; ++i) {
      const player = this.localPlayers[i];
      player.currentRoomId = roomId;
      player.hostedRooms.push(roomId);
      this.roomSubs[roomId] = this.roomSubs[roomId] ?? [];
      if (host === player) {
        this.roomSubs[roomId].push(
          this.on("requestState", (playerId, _roomId, playerConfig) => {
            if (!this.stateRequested) {
              this.stateRequested = [[playerId, JSON.parse(playerConfig || "{}")]];
            } else {
              this.stateRequested.push([playerId, JSON.parse(playerConfig || "{}")]);
            }
          })
        );
      }
    }
    this._onPlayerJoin = options.onPlayerJoin;
    this._onPlayerLeave = options.onPlayerLeave;
    this.subscribeFrame(roomId);
    const roomState = this.roomStates[roomId];
    roomState.gameModel = new GameModel(
      GameCoordinator.GetInstance(),
      options.gameInstance,
      options.seed,
      options.coreOverrides
    );
    roomState.gameModel.roomId = roomId;
    roomState.gameModel.paused = true;
    roomState.gameModel.localNetIds = this.localPlayers.map((player) => player.netId).sort();
    options.buildWorld(roomState.gameModel, players[0].config);
    for (let i = 0; i < players.length; ++i) {
      const player = players[i];
      this.createPlayer(roomState.gameModel, player.netId, player.config, roomState.gameModel.frame);
    }
    this.rooms[roomId] = {
      rebalanceOnLeave: options.rebalanceOnLeave ?? false,
      host: host.netId,
      players: players.map((player) => player.netId),
      roomId
    };
    return roomState.gameModel;
  }
  async host(roomId, {
    gameInstance,
    seed,
    coreOverrides,
    buildWorld,
    onPlayerJoin,
    onPlayerLeave,
    rebalanceOnLeave,
    playerConfig
  }) {
    var _a;
    if (!this.localPlayers.every((player) => player.connected) && !this.options.solohost) {
      await this.connect();
    }
    this.cleanup();
    (_a = this.touchListener) == null ? void 0 : _a.replaceRegions(this.options.touchRegions ?? []);
    for (let i = 0; i < this.localPlayers.length; ++i) {
      let player = this.localPlayers[i];
      player.currentRoomId = roomId;
      player.hostedRooms.push(roomId);
    }
    this.roomSubs[roomId] = this.roomSubs[roomId] ?? [];
    this.roomSubs[roomId].push(
      this.on("requestState", (playerId, _roomId, playerConfig2) => {
        if (!this.stateRequested) {
          this.stateRequested = [[playerId, JSON.parse(playerConfig2 || "{}")]];
        } else {
          this.stateRequested.push([playerId, JSON.parse(playerConfig2 || "{}")]);
        }
      })
    );
    this._onPlayerJoin = onPlayerJoin;
    this._onPlayerLeave = onPlayerLeave;
    this.subscribeFrame(roomId);
    const roomState = this.roomStates[roomId];
    roomState.gameModel = new GameModel(GameCoordinator.GetInstance(), gameInstance, seed, coreOverrides);
    roomState.gameModel.roomId = roomId;
    let localPlayers = this.localPlayers.sort();
    let firstPlayerConfig = {
      ...localPlayers[0].config,
      ...playerConfig
    };
    roomState.gameModel.localNetIds = localPlayers.map((player) => player.netId);
    buildWorld(roomState.gameModel, firstPlayerConfig);
    for (let i = 0; i < localPlayers.length; ++i) {
      const player = localPlayers[i];
      this.createPlayer(
        roomState.gameModel,
        player.netId,
        {
          ...player.config,
          ...playerConfig
        },
        roomState.gameModel.frame
      );
    }
    this.updateRoom({
      rebalanceOnLeave: rebalanceOnLeave ?? false,
      host: localPlayers[0].netId,
      players: roomState.gameModel.localNetIds,
      roomId
    });
    return roomState.gameModel;
  }
  createPlayer(gameModel, playerId, playerConfig, frame) {
    const entityId = this._onPlayerJoin(gameModel, playerId, playerConfig);
    console.log("CREATING PLAYER", playerId);
    this.generateFrameStack(gameModel, playerId, frame);
    return entityId;
  }
  handleInput(gameModel) {
    const players = gameModel.getComponentActives("PlayerInput");
    const roomState = this.roomStates[gameModel.roomId];
    for (let i = 0; i < players.length; ++i) {
      let player = players[i];
      if (gameModel.hasComponent(player, PlayerInputSchema)) {
        const PlayerInput = gameModel.getTypedUnsafe(player, PlayerInputSchema);
        const netId = PlayerInput.id;
        const localPlayer = this.localPlayers.find((player2) => player2.netId === netId);
        if (localPlayer && gameModel.frame + this.frameOffset > roomState.frameStack[netId][roomState.frameStack[netId].length - 1].frame) {
          const currentKeyMap = this.inputManager.getKeyMap(localPlayer.inputType, localPlayer.inputIndex);
          const frame = {
            keys: this.inputManager.keyMapToJsonObject(currentKeyMap),
            frame: gameModel.frame + this.frameOffset,
            playerId: localPlayer.netId,
            events: this.eventsManager.getEvents()
          };
          this.emit("frame", frame);
        }
        if (roomState.frameStack[netId][0].frame === gameModel.frame) {
          const prevKeyMap = PlayerInput.keyMap;
          const frame = roomState.frameStack[netId].shift();
          const nextKeyMap = frame.keys;
          PlayerInput.prevKeyMap = prevKeyMap;
          PlayerInput.keyMap = nextKeyMap;
          PlayerInput.events = frame.events;
        }
      }
    }
  }
  run(gameModel) {
    var _a, _b, _c, _d;
    const roomState = this.roomStates[gameModel.roomId];
    if ((_a = this.stateRequested) == null ? void 0 : _a.length) {
      while ((_b = this.stateRequested) == null ? void 0 : _b.length) {
        const [playerId, playerConfig] = this.stateRequested.pop();
        this.createPlayer(gameModel, playerId, playerConfig, gameModel.frame);
      }
      this.stateRequested = null;
      this.sendingState = true;
      const state = gameModel.serializeState();
      const frameStack = Object.entries(roomState.frameStack).reduce(
        (acc, [key, value]) => {
          acc[key] = value.map((frame) => {
            return {
              keys: this.inputManager.keyMapToJsonObject(frame.keys),
              frame: frame.frame
            };
          });
          return acc;
        },
        {}
      );
      this.emit("state", JSON.stringify(state), frameStack, +/* @__PURE__ */ new Date());
      gameModel.loadStateObject(state);
    }
    if (gameModel.frame % 300 === 0) {
      const perf = performance.now();
      const physicsSystem = gameModel.getSystem(PhysicsSystem);
      (_c = physicsSystem == null ? void 0 : physicsSystem.getEngine) == null ? void 0 : _c.call(physicsSystem, gameModel);
      var uint8array = (_d = physicsSystem.world) == null ? void 0 : _d.takeSnapshot();
      var string = new TextDecoder().decode(uint8array);
      const md5String = md5(string);
      console.log(gameModel.frame, md5String, performance.now() - perf);
    }
  }
}
export {
  CoreConnectionInstance
};
//# sourceMappingURL=CoreConnectionInstance.js.map
